// src/admin/pros/BulkActionBar.jsx
import React from "react";

export default function BulkActionBar({
  selectedCount,
  onApprove,
  onSuspend,
  onExport,
  onClear
}) {
  if (selectedCount === 0) return null;

  return (
    <div style={{
      display: "flex",
      alignItems: "center",
      gap: 12,
      background: "#0F172A",
      borderRadius: 8,
      padding: "0 16px",
      height: 38
    }}>
      <span style={{
        fontSize: 13,
        fontWeight: 600,
        color: "#fff",
        fontFamily: "'Plus Jakarta Sans', sans-serif"
      }}>
        {selectedCount} selected
      </span>
      <div style={{ width: 1, height: 20, background: "rgba(255,255,255,0.25)" }} />
      <button
        onClick={onApprove}
        style={{
          background: "transparent",
          border: "1px solid rgba(255,255,255,0.25)",
          borderRadius: 6,
          padding: "5px 12px",
          fontSize: 12,
          fontWeight: 600,
          color: "#fff",
          cursor: "pointer",
          fontFamily: "'Plus Jakarta Sans', sans-serif"
        }}>
        ✓ Approve
      </button>
      <button
        onClick={onSuspend}
        style={{
          background: "transparent",
          border: "1px solid rgba(255,255,255,0.25)",
          borderRadius: 6,
          padding: "5px 12px",
          fontSize: 12,
          fontWeight: 600,
          color: "#fff",
          cursor: "pointer",
          fontFamily: "'Plus Jakarta Sans', sans-serif"
        }}>
        ⊘ Suspend
      </button>
      <button
        onClick={onExport}
        style={{
          background: "transparent",
          border: "1px solid rgba(255,255,255,0.25)",
          borderRadius: 6,
          padding: "5px 12px",
          fontSize: 12,
          fontWeight: 600,
          color: "#fff",
          cursor: "pointer",
          fontFamily: "'Plus Jakarta Sans', sans-serif"
        }}>
        ↓ Export
      </button>
      <button
        onClick={onClear}
        style={{
          background: "transparent",
          border: "none",
          fontSize: 16,
          color: "#fff",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          padding: "0 4px"
        }}>
        ✕
      </button>
    </div>
  );
}